<template>
    <div class="demo-inline-spacing">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="save"
        >
            {{ $t('Component(Button):save') }}
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="close"
        >
            {{ $t('Component(Button):close') }}
        </b-button>
    </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BButton
    },
    directives: {
        Ripple
    },
    methods: {
        close() {
            this.$emit('close');
        },
        save() {
            this.$emit('save');
        },
    }
}
</script>
